export const chartIntervalValues = ['1d', '1m', '6m', '12m'] as const;
export type ChartInterval = typeof chartIntervalValues[number];
